export enum TokenActionType {
  Buy = 1,
  Deposit = 2,
  Withdraw = 3
}
